import { format } from 'date-fns';
import useFindRetailersQuery from '@/api/queries/useFindRetailersQuery';
import Button from '@/components/Button';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import StatusActiveIndicator from '@/components/StatusActiveIndicator';
import { isStatusActive } from '@/models/Status';
import { RetailerEditPath, RetailerStoreListPath } from '@/modules/admin/paths';
import { Link } from 'react-router-dom';

const RetailerTable = ({ searchQuery, page = 1, onChangePage = () => {} }: SearchProps) => {
  const { retailers, isLoading, itemsPerPage } = useFindRetailersQuery(page, searchQuery);

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Created At</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {retailers.items.map((retailer) => {
              if (!retailer.id) return null;
              return (
                <tr key={retailer.id}>
                  <td>
                    <Link
                      to={RetailerEditPath.withId(retailer.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {retailer.name}
                    </Link>
                  </td>
                  <td>
                    {retailer.createdAt && format(new Date(retailer.createdAt), 'd MMM yyyy')}
                  </td>
                  <td>
                    <StatusActiveIndicator isActive={isStatusActive(retailer)} />
                  </td>
                  <td>
                    <Button
                      to={RetailerStoreListPath.withRetailerId(retailer.id)}
                      variant="secondary"
                      size="xs"
                    >
                      View Stores
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading && (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={retailers.totalCount || 0}
          estimatedTotalCount={retailers.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default RetailerTable;
